import { useCallback, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { deleteKnockStatus } from '@user/store/knockStatus'
import { toast } from '@sales-center/components'

export const useDeleteKnockStatusHandlers = (onClose: () => void) => {
  const dispatch = useAppDispatch()
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = useCallback(
    async (id: string) => {
      try {
        setIsDeleting(true)
        await dispatch(deleteKnockStatus(id)).unwrap()
        toast.success('Knock status deleted successfully')
        onClose()
      } catch (error: any) {
        toast.error(
          error?.Message || 'An error occurred while deleting the knock status',
        )
      } finally {
        setIsDeleting(false)
      }
    },
    [dispatch, onClose],
  )

  return {
    handleDelete,
    isDeleting,
  }
}
